module.exports = __webpack_public_path__ + "img/slide2.0f4a52e1.jpg";